import { render, staticRenderFns } from "./customerCheckVouch.vue?vue&type=template&id=48c582c0&scoped=true&"
import script from "./customerCheckVouch.vue?vue&type=script&lang=js&"
export * from "./customerCheckVouch.vue?vue&type=script&lang=js&"
import style0 from "./customerCheckVouch.vue?vue&type=style&index=0&id=48c582c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c582c0",
  null
  
)

export default component.exports